export default __webpack_public_path__ + "static/media/biomasse_oli.8ca8b8da.svg";